import React from 'react';
import BlockLayout from './BlockLayout';
import * as Styled from './styles';

export default () => (
    <Styled.Wrapper>
        <div>
            <Styled.LayoutBox>
                <BlockLayout name="block-3" layout={[1 / 3, 1 / 3, 1 / 3]} label="3 blocks of 33.3%" firstInRow />
                <BlockLayout name="block-2" layout={[1 / 2, 1 / 2]} label="2 blocks of 50%" />
                <BlockLayout name="block-1" layout={[1]} label="1 block of 100%" lastInRow />
                <BlockLayout name="block-4" layout={[1 / 4, 1 / 4, 1 / 4, 1 / 4]} label="4 blocks of 25%" firstInRow />
                <BlockLayout name="block-5" layout={[2 / 3, 1 / 3]} label="2 blocks of 66.6% and 33.3%" />
                <BlockLayout name="block-6" layout={[1 / 3, 2 / 3]} label="2 blocks of 33.3% and 66.6%" lastInRow />
                <BlockLayout
                    name="block-7"
                    layout={[1 / 2, 1 / 4, 1 / 4]}
                    label="3 blocks of 50%, 25% and 25%"
                    firstInRow
                />
                <BlockLayout name="block-8" layout={[1 / 4, 1 / 4, 1 / 2]} label="3 blocks of 25%, 25% and 50%" />
                <BlockLayout
                    name="block-9"
                    layout={[1 / 4, 1 / 2, 1 / 4]}
                    label="3 blocks of 25%, 50% and 25%"
                    lastInRow
                />
            </Styled.LayoutBox>
        </div>
    </Styled.Wrapper>
);
